/* eslint-disable */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { langCodes } from './constants/lang-codes';

const resources = {
  en: {
    translation: {
      language: {
        text: 'Language',
      },
      appearance: 'Appearance',
      logout: 'Logout',
      balances: 'Balances',
      transactions: 'Transactions',
      mode: {
        light: 'Light',
        dark: 'Dark',
      },
      section: {
        'puk-retrieval': 'PUK Retrieval',
        'sim-details': 'SIM Details',
      },
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: langCodes.english,
    fallbackLng: langCodes.english,
    interpolation: {
      escapeValue: false,
    },
  })
  .catch((err) => {
    console.error('i18n init error:', err);
  });

i18n.on('languageChanged', (lng) => {
  console.log(`[i18n] Detected language change to: ${lng}`);
});

export default i18n;
